<template>
  <v-app-bar elevation="0" class="app-header">
    <v-toolbar color="surface" class="app-header-toolbar pr-1">
      <v-btn
        v-if="isAuthenticated"
        :icon="`mdi-menu-${expand ? 'close' : 'open'}`"
        class="header-icon-btn"
        @click="changeExpandMenu"
        style="left: -5px"
      >
      </v-btn>

      <v-hover disabled>
        <div v-if="store.getters.getShowLarge" style="border: 0px solid black;  display: grid;grid-template-columns: 80% 10% 10%"> 
          <div>
          <img
            :src="isDarkTheme ? vectiUpperDark : vectiUpper"
            alt="Logo"
            width="90"
            class="ml-5"
            @click="loadHome"
          />
        </div>    
        <div><v-spacer></v-spacer></div>
        <div>
        <v-icon class="ml-1" @click="loadChangeLog">mdi-star-check</v-icon>
        </div>
        
        </div>
        <div v-else>
          <img src="/img/v-logo.png" class="logo-xs" />
        </div>
      </v-hover>
      <v-spacer></v-spacer>

      <div v-if="store.getters.getUserExtended && isAuthenticated" style="padding: 0px">
        <ShowUserCompanies
          :listCompanies="store.getters.getUserExtended.companies"
          :default_company="store.getters.getUserExtended.default_company"
        />
      </div>
      <v-spacer></v-spacer>

      <div v-if="!isAuthenticated">
        <LoginButton />
        <RegisterButton v-if="!isRegisterPath" />
      </div>

      <v-menu>
        <v-btn flat slot="activator" color="yellow">
          <v-icon icon="mdi-arrow-left" left></v-icon>
          <span>Menu</span>
        </v-btn>
      </v-menu>

      <div>
        <SubscriptionButton v-if="!store.getters.getInUseCompanyHasActiveSubscription" />
      </div>

      <div
        v-if="
          store.getters.getInUseCompanyHasAccount ||
          store.getters.getInUseCompanyHasTaxAgency
        "
      >
        <div>
          <v-btn
            color="green-darken-2"
            size="small"
            class="ma-1"
            variant="elevated"
            v-if="
              isAuthenticated &&
              (store.state.inUseCompany !== null || store.state.inUseCompany != '')
            "
          >
            <div v-if="store.getters.getShowLarge">
              <v-icon icon="mdi-arrow-down" left></v-icon>Actualizar {{ month }}
            </div>
            <div v-else>
              <v-icon icon="mdi-update" left></v-icon>
            </div>

            <v-menu activator="parent">
              <v-list>
                <v-list-item base-color="green-darken-3" size="small">
                  <v-list-item-title
                    @click="bank"
                    v-if="store.getters.getInUseCompanyHasAccount"
                    >Banco</v-list-item-title
                  >
                  <v-list-item-title
                    @click="sii"
                    v-if="store.getters.getInUseCompanyHasTaxAgency"
                    >SII</v-list-item-title
                  >
                  <v-list-item-title
                    @click="conciliation"
                    v-if="store.getters.getInUseCompanyHasAccount"
                    >Conciliación</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-btn>
        </div>
      </div>
      <LogoutButton />
    </v-toolbar>
  </v-app-bar>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { onMounted } from "vue";
import { useTheme } from "vuetify";
import vectiUpper from "../assets/img/vecti-upper.png";
import vectiUpperDark from "../assets/img/vecti-upper-dark.png";

/*
onMounted(async () => {
  console.log("onmounted");
  try {
    if (isAuthenticated.value) {
      console.log("isAuthenticated.value: " + isAuthenticated.value);
      let vecti_user = useUser();
      console.log("vecti_user (header):" + JSON.stringify(vecti_user));
      user_ex = useUserExtended(vecti_user);
    }
  } catch (e) {
    console.log("Error en vecti_user (header): " + e);
  }
});
*/

const { isAuthenticated } = useAuth0();
const theme = useTheme();
const isDarkTheme = computed(() => theme.global.current.value.dark);
const expand = ref(store.getters.getExpandMenu);
const route = useRoute();
    const router = useRouter();
watch(
  () => store.getters.getUserExtended,
  (newVal) => {
    console.log("(header) cambio user extended " );
  }
);

watch(
  () => store.getters.getInUseCompanyHasActiveSubscription,
  (newVal) => {
    console.log(
      "(header): store.getters.getInUseCompanyHasActiveSubscription change: " +
        store.getters.getInUseCompanyHasActiveSubscription
    );
  }
);

/*
watch(
  () => isAuthenticated.value,
  (newVal) => {
    console.log("isAuthenticated.value (header): " + newVal);
    if (newVal) {
      let vecti_user = useUser();
      console.log("vecti_user (header):" + vecti_user);
      user_ex = useUserExtended(vecti_user);
    }
  }
);
*/
watch(
  () => store.getters.getInUseCompanyHasAccount,
  (newVal) => {
    console.log("(header) store.getters.getInUseCompanyHasAccount: " + newVal);
  }
);

const isRegisterPath = computed(() => {
  const currentPath = route.path;


  if (currentPath === "/register") {
    return true;
  }
  return false;
});

//let user_ex = ref(null);
let user_ex = null;

const loadHome=() =>{
router.push("/home");
}

const loadChangeLog= () =>{
router.push('/changelog');
}

const changeExpandMenu = () => {
  expand.value = !expand.value;
  store.commit("setExpandMenu", expand.value);
};

const bank = async () => {
  store.dispatch("openNotification", {
    message: "Actualizando información bancaria",
    duration: 1500,
  });
  try {
    console.log("Sincronizando información bancaria: " + store.state.inUseCompany);
    const vectiResult = await useSynchcronizeBank(store.state.inUseCompany);
    console.log("vectiResult: " + JSON.stringify(vectiResult));

    //store.dispatch("updateMenuSelection");
    if (vectiResult) {
      store.dispatch("openNotification", {
        message: "Sincronización bancaria exitosa",
        duration: 1500,
      });
      store.commit("setReloadMenu", true);
    } else {
      store.dispatch("openNotification", {
        message: "Error en la sincronizacion bancaria",
        duration: 1500,
      });
    }
  } catch (e) {
    console.log("Error en sincronización bancaria: " + e);
    store.dispatch("openNotification", {
      message: "Error en la sincronizacion bancaria:" + e,
      duration: 1500,
    });
  }
};

const sii = async () => {
  store.dispatch("openNotification", {
    message: "Actualizando información del SII",
    duration: 1500,
  });
  try {
    console.log("Sincronizando información del SII: " + store.state.inUseCompany);
    const vectiResult = await useSynchcronizeSII(store.state.inUseCompany);
    console.log("vectiResult: " + JSON.stringify(vectiResult));
    if (vectiResult) {
      store.dispatch("openNotification", {
        message: "Sincronización SII exitosa",
        duration: 1500,
      });
      console.log("setUpdateSII prev: " + store.state.updateSII);
      store.commit("setUpdateSII", true);
      console.log("setUpdateSII after: " + store.state.updateSII);
    } else {
      store.dispatch("openNotification", {
        message: "Error en la sincronizacion del SII",
        duration: 1500,
      });
    }
  } catch (e) {
    console.log("Error en sincronización del SII: " + e);
    store.dispatch("openNotification", {
      message: "Error en la sincronizacion del SII:" + e,
      duration: 1500,
    });
  }
};

const conciliation = async () => {
  store.dispatch("openNotification", {
    message: "Actualizando conciliacion automática",
    duration: 1500,
  });
  try {
    console.log("Actualizando información de conciliacion: " + store.state.inUseCompany);
    const vectiResult = await useSynchcronizeAutoconciliation(store.state.inUseCompany);
    console.log("vectiResult: " + JSON.stringify(vectiResult));
    if (vectiResult) {
      store.dispatch("openNotification", {
        message: "Actualización de conciliación exitosa",
        duration: 1500,
      });
    } else {
      store.dispatch("openNotification", {
        message: "Error en la actualizacion de conciliacion",
        duration: 1500,
      });
    }
  } catch (e) {
    console.log("Error en sincronización del SII: " + e);
    store.dispatch("openNotification", {
      message: "Error en la actualizacion de conciliacion:" + e,
      duration: 1500,
    });
  }
};

const month = new Date().toLocaleString("default", { month: "long" });
</script>
